































import { Component, Vue } from 'vue-property-decorator';
import storage from '../../utils/storage';
import Loading from '../../components/Loading.vue';
import tableModel from '../../components/table/tableModel.vue';
import PmModalBox from '../../components/PmModalBox.vue';
@Component({
  components: {
    Loading,
    PmModalBox,
    tableModel,
  },
})
export default class EditorPMProduct extends Vue {
  private user: any;
  private spinning = false;
  private maskClosable: boolean = false;
  private visible: boolean = false;
  private pmModalTitle: string = '创建PM';
  private selectDataJson: any = [];
  private editorProductNum: string = '';
  private searchPM: string = '家伟';
  private dataJson: any = [];
  private columns: any = [{
    title: 'id',
    dataIndex: 'id',
    width: '3%',
    scopedSlots: { customRender: 'id' },
  }, {
    title: 'pmName',
    dataIndex: 'pmName',
    width: '4%',
    scopedSlots: { customRender: 'pmName' },
  }, {
    title: 'productName',
    dataIndex: 'productName',
    width: '12%',
    scopedSlots: { customRender: 'productName' },
  }, {
    title: 'productNumber',
    dataIndex: 'productNumber',
    width: '8%',
    scopedSlots: { customRender: 'productNumber' },
  }, {
    title: 'asin',
    dataIndex: 'asin',
    width: '8%',
    scopedSlots: { customRender: 'asin' },
  }, {
    title: 'Brand',
    dataIndex: 'brand',
    width: '7%',
    scopedSlots: { customRender: 'brand' },
  }, {
    title: 'store',
    dataIndex: 'store',
    width: '4%',
    scopedSlots: { customRender: 'store' },
  }];
  private argsJson: any = {
    pmName: '',
    pmNameAbb: '',
    productName: '',
    asin: '',
    brand: '',
    store: '',
  };
  private mounted() {
    this.user = storage.get('user');
    if (this.user) {
      this.handleChange(this.searchPM, 'pmName', 'empty');
      this.getSelectData();
    } else {
     this.$router.push({
        path: '/login',
      });
    }
  }
  private getDataRefresh() {
    this.handleChange(this.searchPM, 'pmName', 'empty');
  }
  // private async getData() {
  //   const that = this;
  //   this.spinning = true;
  //   // 清空数组
  //   const url: string = '/api/getTracking';
  //   const args = {
  //     pmName: this.searchPM,
  //   };
  //   const data = await this.axios.post(url, args);
  //   this.spinning = false;
  // }
  private handleChange(value: string, type: string, asinType: string) {
    const that = this;
    if ( type === 'pmName' ) {
      const url = '/api/getPmInfo';
      const args = {
        pmName: value,
      };
      this.axios.post(url, args).then((res) => {
        if (res.data.data) {
          that.dataJson = res.data.data;
        }
      });
    }
  }
  private async getSelectData() {
    const that = this;
    this.spinning = true;
    // 清空数组
    const url: string = '/api/getSelectTracking';
    const args = {
      team: this.user.team,
    };
    this.axios.post(url, args).then((res) => {
      that.selectDataJson = res.data.data;
      that.spinning = false;
    });
  }
  private showModal() {
    this.visible = true;
    this.editorProductNum = '';
  }
  private productNumhandleOk(e: any) {
    this.visible = false;
    if ( this.pmModalTitle === '修改' ) {
      (this.$refs.PmModalBoxRef as any).editorShowModal(false, this.editorProductNum);
    } else if ( this.pmModalTitle === '删除' ) {
      (this.$refs.PmModalBoxRef as any).deleteShowModal(false, this.editorProductNum);
    }
  }
  private changeProductNum(e: any) {
    console.log(e);
  }
  private async clickPmModal(boo: boolean, titleStatus: string, data: any) {
    this.pmModalTitle = titleStatus;
    if ( titleStatus === '创建' ) {
      (this.$refs.PmModalBoxRef as any).showModal(boo, titleStatus, data);
    } else if ( titleStatus === '修改' ) {
      this.showModal();
    } else if ( titleStatus === '删除' ) {
      this.showModal();
    }
  }

}
